/** Nunca pantalla en blanco (CLAUDE.md §6): forma del tablero mientras carga. */
export function BoardSkeleton() {
  return (
    <div className="flex gap-4 overflow-hidden p-6" aria-hidden="true">
      {[0, 1, 2].map((column) => (
        <div key={column} className="flex w-72 shrink-0 flex-col gap-2">
          <div className="mb-1 h-5 w-24 animate-pulse rounded-card bg-surface" />
          {[0, 1, 2].map((card) => (
            <div key={card} className="h-20 animate-pulse rounded-card bg-surface" />
          ))}
        </div>
      ))}
    </div>
  )
}
